import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const SrCheckbox = ({
  children,
  checked,
  onClick,
}) => (
  <div
    className={classNames('SrCheckbox', {
      checked: checked,
    })}
    onClick={onClick}
  >
    <div>
      <div className='icon' />
    </div>
    <span className='text'>{children}</span>
  </div>
);

SrCheckbox.propTypes = {
  children: PropTypes.node.isRequired,
  checked: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

SrCheckbox.defaultProps = {
  checked: false,
};

SrCheckbox.displayName = 'SrCheckbox';

export default SrCheckbox;
